import React from 'react'
import { Box, IconButton, Paper, Typography } from '@mui/material'
import { TooltipRenderProps } from 'react-joyride'
import Header, { HeaderVariant } from './Header'
import Close from '@mui/icons-material/Close'
import CardFormHeader from '../Card/CardFormHeader'

export const JoyrideTooltip: React.FC<TooltipRenderProps> = ({
  primaryProps,
  step,
  tooltipProps,
}) => {
  return (
    <Box
      {...tooltipProps}
      border={'none'}
      py={2}
      px={{ xs: 2, lg: 3 }}
      maxWidth={420}
      minWidth={290}
      overflow="hidden"
      component={Paper}
    >
      <Box padding="xs">
        <IconButton
          aria-label="close"
          sx={{ position: 'fixed', top: 4, right: 22 }}
          onClick={primaryProps.onClick}
        >
          <Close />
        </IconButton>
        <>
          {step.title && (
            <CardFormHeader
              headerContainerProps={{
                marginTop: 0,
                marginLeft: 0,
              }}
              header={
                <Header
                  css={{
                    padding: 0,
                  }}
                  variant={HeaderVariant.Card}
                  headerName={`${step.title}`}
                />
              }
            />
          )}
          <Box pb={1}>
            {step.content && (
              <Typography variant="body1">{step.content}</Typography>
            )}
          </Box>
        </>
      </Box>
    </Box>
  )
}

export default JoyrideTooltip
